<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="handleBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>订单详情</p>
      </div>
      <div class="right">
        <!-- 刷新支付 -->
        <div
          class="mwow-button info"
          @click="handleRefresh"
          style="min-width: 48px; text-align: center"
          v-if="
            (mainData.order_type === 1 || mainData.order_type === 3) &&
            mainData.status === 1 &&
            mainData.payment_type === 1
          "
        >
          {{ refreshCD > 0 ? refreshCD + "s" : "刷新支付" }}
        </div>
        <!-- 退款：支付成功或者部分支付且审批通过课时已发放时才可以进行退款 -->
        <div
          class="mwow-button info"
          v-debounce="1000"
          @click="toRefund"
          v-if="
            !mainData.org_pay_order_chargeback_exist &&
            mainData.order_type === 1 &&
            mainData.status === 5 &&
            (mainData.approval_status === 0 || mainData.approval_status === 2)
          "
        >
          退款
        </div>
        <!-- 在线支付：待付款或者部分付款可点击支付 -->
        <div
          class="mwow-button success"
          v-debounce="1000"
          @click="handlePaymentTypeDialog"
          v-if="
            !mainData.org_pay_order_chargeback_exist &&
            (mainData.order_type === 1 || mainData.order_type === 3) &&
            (mainData.status === 1 || mainData.status === 5) &&
            mainData.payment_type === 1
          "
        >
          支付
        </div>
        <!-- 取消订单 -->
        <div
          class="mwow-button info"
          v-debounce="1000"
          @click="handelCancelOrder"
          v-if="mainData.order_type === 1 && mainData.status === 1"
        >
          取消订单
        </div>
        <!-- 购课订单，非取消状态，无审批或审批通过，可以打印 -->
        <div
          @click="handlePrint"
          v-if="
            mainData.order_type === 1 &&
            mainData.status === 2 &&
            approveData.status !== 3 &&
            (mainData.approval_status === 0 || mainData.approval_status === 2)
          "
          class="mwow-button primary"
          v-debounce="1000"
        >
          打印
        </div>
        <!--  购课订单，已付款，审批未通过，可以编辑订单信息 -->
        <div
          v-if="
            mainData.order_type === 1 &&
            mainData.status === 2 &&
            approveData.status === 3
          "
        >
          <div class="mwow-button success" v-debounce="1000" @click="toEdit">
            编辑订单信息
          </div>
        </div>
        <!-- 
          购课订单，已取消，可以再来一单
          购课订单，退单成功，可以再来一单
         -->
        <div
          v-if="
            (mainData.order_type === 1 && mainData.status === 4) ||
            (mainData.order_type === 5 && mainData.status === 2)
          "
        >
          <div class="mwow-button info" @click="toBuyConfirm">再来一单</div>
        </div>
        <!-- 退款订单，新支付流程，审批中，可执行取消，取消退款只有退单业务才出现 -->
        <div
          v-if="
            mainData.online_pay &&
            mainData.order_type === 5 &&
            mainData.refund_method > 0 &&
            mainData.approval_status === 1
          "
        >
          <div class="mwow-button warning" @click="handleCancelRefund">
            取消退款
          </div>
        </div>
        <!-- 统一使用 abolish_support 来判断是否可以废除，不用判断是否开通线上支付 -->
        <div v-if="mainData.abolish_support && mainData.status !== 3">
          <abolish-dialog
            :orderId="Number($route.query.id)"
            :orderNo="mainData.order_no"
            @on-close="init"
          >
            <div class="mwow-button warning">废除</div>
          </abolish-dialog>
        </div>
      </div>
    </div>
    <div :class="printing ? 'printing' : ''" ref="print">
      <div class="detail-head">
        <!-- 审批信息 -->
        <div
          class="approve-wrap"
          v-if="mainData.order_id && mainData.approval_id"
        >
          <div class="status-tag">
            <img
              v-if="approveData.status === 1"
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/wait-l.png"
              width="70"
              height="55"
            />
            <img
              v-if="approveData.status === 2"
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/pass-l.png"
              width="70"
              height="55"
            />
            <img
              v-if="approveData.status === 3"
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/reject-l.png"
              width="70"
              height="55"
            />
            <img
              v-if="approveData.status === 4"
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/cancel-l.png"
              width="70"
              height="55"
            />
          </div>
          <div
            :class="`approve-title ${
              ['', 'wait', 'pass', 'reject', 'cancel'][approveData.status]
            }`"
          >
            审批信息 -
            <span
              style="color: #07d1aa; cursor: pointer"
              @click="toApproveDetail"
            >
              {{ approveData.approval_no }}
            </span>
          </div>
          <div class="approve-content">
            <div class="rows">
              <div class="row">
                <p class="title">
                  <img
                    class="icon"
                    src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/pass-s.png"
                    width="18"
                    height="18"
                  />
                  <span>{{ approveData.initiate_staff.name }}</span>
                  <span
                    v-if="
                      approveData.initiate_staff.name === staffName.staff_name
                    "
                  >
                    &nbsp; (我)
                  </span>
                  <span class="status">发起申请</span>
                  <span class="border">|</span>
                  <span>{{
                    ["", "购课", "退课", "转课", "购活动", "退单"][
                      mainData.order_type
                    ]
                  }}</span>
                </p>
                <p class="time">发起时间：{{ approveData.create_time }}</p>
              </div>
              <div
                class="row"
                v-for="(item, index) in approveData.approval_staff_list"
                :key="index"
              >
                <p class="title bold">
                  <img
                    class="icon"
                    src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/wait-s.png"
                    width="18"
                    height="18"
                    v-if="item.sub_status === 1"
                  />
                  <img
                    class="icon"
                    src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/pass-s.png"
                    width="18"
                    height="18"
                    v-if="item.sub_status === 2"
                  />
                  <img
                    class="icon"
                    src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/reject-s.png"
                    width="18"
                    height="18"
                    v-if="item.sub_status === 3"
                  />
                  <span>{{ item.staff.name }}</span>
                  <span class="mwow-red status" v-if="item.sub_status === 1"
                    >审批中</span
                  >
                  <span class="mwow-green status" v-if="item.sub_status === 2"
                    >已批准</span
                  >
                  <span class="mwow-gray status" v-if="item.sub_status === 3"
                    >未批准</span
                  >
                </p>
                <p
                  class="time"
                  v-if="item.approval_time && item.sub_status !== 1"
                >
                  审批时间：{{ item.approval_time }}
                </p>
                <p class="desp" v-if="item.remark">
                  审批备注：{{ item.remark }}
                </p>
              </div>
              <div
                v-if="
                  (mainData.order_type === 2 || mainData.order_type === 5) &&
                  approveData.status === 2 &&
                  mainData.refund_method > 0 &&
                  voucher_url
                "
                class="row voucher"
              >
                <p class="title bold">
                  {{ mainData.refund_transfer_staff.name }}
                  <span class="mwow-green status">已转账</span>
                </p>
                <p class="time">
                  转账时间：<span>{{ mainData.handle_time }}</span>
                </p>
                <p class="desp" v-if="mainData.refund_transfer">
                  转账凭证：
                  <el-image
                    :src="mainData.refund_transfer.voucher_url"
                    :preview-src-list="[mainData.refund_transfer.voucher_url]"
                  >
                  </el-image>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 订单信息 -->
        <div class="order-wrap">
          <p
            class="order-title"
            :class="{
              limit: !(mainData.order_id && mainData.approval_id),
            }"
          >
            <span class="text">订单信息 - {{ mainData.order_no }}</span>
            <span class="payment-status">
              <img
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/approve/repeal-l.png"
                v-if="mainData.status === 3"
                class="repeal"
                width="70"
                height="55"
              />
              <span v-else>
                {{ handlePaymentStatus() }}
              </span>
            </span>
          </p>
          <div class="order-content">
            <p class="user">
              <span v-if="mainData.order_type === 3">[转出] &nbsp;</span>
              <span class="name">{{ mainData.student.name }}</span
              >{{
                mainData.student.area_code
                  ? "+" + mainData.student.area_code
                  : ""
              }}
              {{ mainData.student.mobile }}
            </p>
            <p class="user" v-if="mainData.order_type === 3">
              <span>[转入] &nbsp;</span>
              <span class="name">{{ mainData.transfer_join_student.name }}</span
              >{{
                "+" +
                mainData.transfer_join_student.area_code +
                " " +
                mainData.transfer_join_student.mobile
              }}
            </p>

            <!-- 购课 -->
            <div class="form" v-if="mainData.order_type === 1">
              <div class="item">
                <span class="label">业务类型：</span>
                <span class="value"> 购课 </span>
              </div>
              <div class="item">
                <span class="label">收支类型：</span>
                <span class="value">收入</span>
              </div>
              <div class="item">
                <span class="label">应收金额：</span>
                <span class="value">￥{{ mainData.receivable_amount }}</span>
              </div>
              <div class="item" v-if="mainData.status !== 1">
                <span class="label">实收金额：</span>
                <span class="value">￥{{ mainData.completed_amount }}</span>
              </div>
              <div
                class="item wait-amount"
                v-if="mainData.status === 1 || mainData.status === 5"
              >
                <span class="label">待付金额：</span>
                <span class="value" style="color: #f56c6c">
                  ￥{{
                    (
                      Number(this.mainData.receivable_amount) -
                      Number(this.mainData.completed_amount)
                    ).toFixed(2)
                  }}
                </span>
                <span>
                  <div
                    class="mwow-button success pay-btn"
                    v-debounce="1000"
                    @click="handlePaymentTypeDialog"
                    v-if="
                      !mainData.org_pay_order_chargeback_exist &&
                      mainData.order_type === 1 &&
                      (mainData.status === 1 || mainData.status === 5)
                    "
                  >
                    支付
                  </div>
                </span>
              </div>
              <div class="item create-staff">
                <span class="label">创建人：</span>
                <span class="value">{{
                  mainData.create_staff && mainData.create_staff.name
                }}</span>
              </div>
              <div class="item">
                <span class="label">业务人员：</span>
                <span class="value">{{
                  mainData.belong
                    .map((item) => {
                      return item.name;
                    })
                    .join(",")
                }}</span>
              </div>
              <div class="item">
                <span class="label">创建时间：</span>
                <span class="value">{{ mainData.create_time }}</span>
              </div>
              <div
                class="item"
                v-if="mainData.order_type === 1 && mainData.status === 4"
              >
                <span class="label">取消时间：</span>
                <span class="value">{{ mainData.cancel_time }}</span>
              </div>
              <div
                class="item"
                v-if="
                  mainData.order_type === 1 &&
                  (mainData.status === 2 || mainData.status === 3)
                "
              >
                <span class="label">支付时间：</span>
                <span class="value" v-if="mainData.handle_time !== '-'">
                  <span
                    v-if="
                      mainData.create_time.slice(0, 10) !==
                      mainData.handle_time.slice(0, 10)
                    "
                    class="mwow-red"
                    >{{ mainData.handle_time }} (非当天)</span
                  >
                  <span v-else>{{ mainData.handle_time }}</span>
                </span>
                <span class="value" v-else>-</span>
              </div>
              <div class="item">
                <span class="label">其他备注：</span>
                <span class="value">{{ mainData.remark || "-" }}</span>
              </div>
            </div>
            <!-- 购课订单时间控制 end-->

            <!-- 退课或退单 -->
            <div
              class="form"
              v-if="mainData.order_type === 2 || mainData.order_type === 5"
            >
              <div class="item">
                <span class="label">业务类型：</span>
                <span class="value" v-show="mainData.order_type === 2"
                  >退课</span
                >
                <span class="value" v-show="mainData.order_type === 5"
                  >退单</span
                >
              </div>
              <div class="item">
                <span class="label">收支类型：</span>
                <span class="value">支出</span>
              </div>
              <div class="item">
                <span class="label">应退金额：</span>
                <span class="value">￥{{ mainData.receivable_amount }}</span>
              </div>
              <div class="item" v-if="mainData.status === 2">
                <span class="label">实退金额：</span>
                <span class="value">￥{{ mainData.completed_amount }}</span>
              </div>
              <div class="item operator">
                <span class="label">操作人员：</span>
                <span class="value">{{
                  mainData.create_staff && mainData.create_staff.name
                }}</span>
              </div>
              <div class="item">
                <span class="label">业务人员：</span>
                <span class="value" v-if="mainData.belong.length > 0">{{
                  mainData.belong
                    .map((item) => {
                      return item.name;
                    })
                    .join(",")
                }}</span>
                <span class="value" v-else>-</span>
              </div>
              <!-- start 退课订单时间控制 -->
              <div class="item">
                <span class="label">创建时间：</span>
                <span class="value">{{ mainData.create_time }}</span>
              </div>
              <div
                class="item"
                v-if="
                  (mainData.order_type === 2 || mainData.order_type === 5) &&
                  (mainData.status === 2 || mainData.status === 1)
                "
              >
                <!-- 无审批、审批中、审批成功、已废除的订单 -->
                <!-- 开通支付审批成功显示，未开通一直显示 -->
                <span class="label">退款时间：</span>
                <span
                  class="value"
                  v-if="
                    (mainData.order_type === 2 || mainData.order_type === 5) &&
                    (approveData.status === 0 ||
                      approveData.status === 1 ||
                      approveData.status === 2 ||
                      mainData.status === 3)
                  "
                >
                  {{ mainData.handle_time ? mainData.handle_time : "-" }}
                </span>
                <span class="value" v-else>
                  {{ online_pay ? "-" : mainData.handle_time }}
                </span>
              </div>
              <div
                class="item"
                v-if="
                  (mainData.order_type === 2 || mainData.order_type === 5) &&
                  mainData.status === 4
                "
              >
                <span class="label">取消时间：</span>
                <span class="value">{{
                  mainData.cancel_time ? mainData.cancel_time : "-"
                }}</span>
              </div>
              <div class="item withdrawal">
                <span class="label">退课原因：</span>
                <span class="value">{{ mainData.remark || "-" }}</span>
              </div>
              <div v-if="mainData.refund_fail_log" style="margin-top: 24px">
                <div class="item">
                  <span class="label">失败时间：</span>
                  <span class="value">{{
                    mainData.refund_fail_log.create_time
                  }}</span>
                </div>
                <div class="item">
                  <span class="label">失败原因：</span>
                  <span class="value">{{
                    mainData.refund_fail_log.reason
                  }}</span>
                </div>
              </div>
            </div>
            <!-- 退课订单时间控制 end-->

            <!-- 转课 -->
            <div class="form" v-if="mainData.order_type === 3">
              <div class="item">
                <span class="label">业务类型：</span>
                <span class="value">转课</span>
              </div>
              <div class="item">
                <span class="label">收支类型：</span>
                <span class="value">{{
                  mainData.payment_type === 1 ? "收入" : "支出"
                }}</span>
              </div>
              <div class="item">
                <span class="label">{{
                  mainData.payment_type == 1 ? "应收金额：" : "应退金额："
                }}</span>
                <span class="value">￥{{ mainData.receivable_amount }}</span>
              </div>
              <div class="item" v-show="mainData.payment_type == 1">
                <span class="label">实收金额：</span>
                <span class="value">￥{{ mainData.completed_amount }}</span>
              </div>
              <div
                class="item"
                v-show="mainData.payment_type == 2 && mainData.status === 2"
              >
                <span class="label">实退金额：</span>
                <span class="value">￥{{ mainData.completed_amount }}</span>
              </div>
              <div class="item"></div>
              <div class="item">
                <span class="label">操作人员：</span>
                <span class="value">{{
                  mainData.create_staff && mainData.create_staff.name
                }}</span>
              </div>
              <div class="item">
                <span class="label">业务人员：</span>
                <span class="value" v-if="mainData.belong.length > 0">{{
                  mainData.belong
                    .map((item) => {
                      return item.name;
                    })
                    .join(",")
                }}</span>
                <span class="value" v-else>-</span>
              </div>
              <div class="item">
                <span class="label">转课时间：</span>
                <span class="value">{{ mainData.create_time }}</span>
              </div>
              <div class="item" v-if="mainData.payment_type === 1">
                <span class="label">支付时间：</span>
                <span class="value" v-if="mainData.handle_time !== '-'">
                  <span
                    v-if="
                      mainData.create_time.slice(0, 10) !==
                      mainData.handle_time.slice(0, 10)
                    "
                    class="mwow-red"
                    >{{ mainData.handle_time }} (非当天)</span
                  >
                  <span v-else>{{ mainData.handle_time }}</span>
                </span>
                <span class="value" v-else>-</span>
              </div>
              <div class="item" v-if="mainData.payment_type === 2">
                <span class="label">退款时间：</span>
                <span
                  class="value"
                  v-if="
                    approveData.status === 0 ||
                    approveData.status === 1 ||
                    approveData.status === 2 ||
                    mainData.status === 3
                  "
                >
                  {{ mainData.handle_time ? mainData.handle_time : "-" }}
                </span>
                <span class="value" v-else>
                  {{ online_pay ? "-" : mainData.handle_time }}
                </span>
              </div>
              <div class="item">
                <span class="label">转课原因：</span>
                <span class="value">{{ mainData.remark || "-" }}</span>
              </div>
            </div>

            <!-- 购活动-->
            <div class="form" v-if="mainData.order_type === 4">
              <div class="item">
                <span class="label">业务类型：</span>
                <span class="value"> 购活动 </span>
              </div>
              <div class="item">
                <span class="label">收支类型：</span>
                <span class="value">收入</span>
              </div>
              <div class="item">
                <span class="label">应收金额：</span>
                <span class="value">￥{{ mainData.receivable_amount }}</span>
              </div>
              <div class="item" v-if="mainData.status === 2">
                <span class="label">实收金额：</span>
                <span class="value">￥{{ mainData.completed_amount }}</span>
              </div>
              <!-- 创建人是官方，则没数据 -->
              <div class="item create-staff">
                <span class="label">创建人：</span>
                <span class="value" v-if="mainData.create_staff">{{
                  mainData.create_staff && mainData.create_staff.name
                }}</span>
                <span class="value" v-else>-</span>
              </div>
              <!-- 创建人是官方，则没数据 -->
              <div class="item">
                <span class="label">业务人员：</span>
                <span class="value">{{
                  mainData.belong
                    .map((item) => {
                      if (item.name) {
                        return item.name;
                      } else {
                        return "-";
                      }
                    })
                    .join(",")
                }}</span>
              </div>
              <div class="item">
                <span class="label">创建时间：</span>
                <span class="value">{{ mainData.create_time }}</span>
              </div>
              <div
                class="item"
                v-if="mainData.order_type === 1 && mainData.status === 4"
              >
                <span class="label">取消时间：</span>
                <span class="value">{{ mainData.cancel_time }}</span>
              </div>
              <div
                class="item"
                v-if="
                  mainData.order_type === 1 &&
                  (mainData.status === 2 || mainData.status === 3)
                "
              >
                <span class="label">支付时间：</span>
                <span class="value" v-if="mainData.handle_time !== '-'">
                  <span
                    v-if="
                      mainData.create_time.slice(0, 10) !==
                      mainData.handle_time.slice(0, 10)
                    "
                    class="mwow-red"
                    >{{ mainData.handle_time }} (非当天)</span
                  >
                  <span v-else>{{ mainData.handle_time }}</span>
                </span>
                <span class="value" v-else>-</span>
              </div>
              <div class="item">
                <span class="label">其他备注：</span>
                <span class="value">{{ mainData.remark || "-" }}</span>
              </div>
            </div>
            <!-- 购活动订单时间控制 end-->
          </div>
        </div>
      </div>
      <!-- 订单废除 -->
      <div class="cancel-order-wrap" v-if="mainData.status === 3">
        <p class="title mwow-yellow">订单废除</p>
        <div class="infobox">
          <el-row>
            <p>操作老师：{{ mainData.cancel_log.operate_name }}</p>
            <p>废除原因：{{ mainData.cancel_log.remark }}</p>
            <p>
              废除时间：{{
                mainData.cancel_log ? mainData.cancel_log.cancel_time : "-"
              }}
            </p>
          </el-row>
        </div>
      </div>
      <!-- 购课 -->
      <div v-if="mainData.order_type === 1">
        <div class="table-wrap">
          <div class="th">
            <div class="td">购买内容</div>
            <div class="td">业务形式</div>
            <div class="td">购买数量</div>
            <div class="td">赠送数量</div>
            <div class="td">直减</div>
            <div class="td">小计</div>
          </div>
          <div class="item" v-for="item in mainData.item" :key="item.item_name">
            <p class="title">
              【{{ item.is_combo ? "套餐" : "课程" }}】-
              {{ item.item_name }}
            </p>
            <div class="tr" v-for="(it, index) in item.list" :key="index">
              <div class="td">
                <span v-if="mainData.order_type === 1">{{
                  item.is_combo ? it.product_name : ""
                }}</span>
                <span v-if="mainData.order_type === 4">
                  {{ item.item_name }}
                </span>
              </div>
              <div class="td">
                <p v-if="it.business_type === 0">-</p>
                <p v-if="it.business_type === 2">续费</p>
                <p v-if="it.business_type === 1">新购</p>
                <p v-if="it.business_type === 3">拓科</p>
              </div>
              <div class="td">{{ it.quantity }}课时</div>
              <div class="td">
                {{ it.give_product_quantity }}
                课时
              </div>
              <div class="td">￥{{ it.discount_amount }}</div>
              <div class="td">￥{{ it.receivable_amount }}</div>
            </div>
          </div>
        </div>
        <p class="sum-wrap">
          <span
            >应付金额：<span class="mwow-green"
              >￥{{ mainData.receivable_amount }}</span
            ></span
          >
        </p>
      </div>
      <!-- 购课end -->

      <!-- 退课或部分支付退单 -->
      <div v-if="mainData.order_type === 2 || mainData.order_type === 5">
        <div class="table-wrap">
          <div class="th">
            <div class="td">订单号</div>
            <div class="td">业务形式</div>
            <div class="td">内容价格</div>
            <div class="td">退课课时</div>
            <div class="td">退课金额</div>
            <div class="td">手续费</div>
          </div>
          <div class="item" v-for="item in mainData.item" :key="item.item_name">
            <p class="title">
              【{{ item.is_combo ? "套餐" : "课程" }}】-
              {{ item.item_name }}
            </p>
            <div class="tr" v-for="(it, index) in item.list" :key="index">
              <div
                class="td"
                style="color: #07d1aa; cursor: pointer"
                @click="toOrderDetail(it)"
              >
                {{ it.relation_order_no }}
              </div>
              <div class="td">
                <p v-if="it.business_type === 0">-</p>
                <p v-if="it.business_type === 2">续费</p>
                <p v-if="it.business_type === 1">新购</p>
                <p v-if="it.business_type === 3">拓科</p>
              </div>
              <div class="td">{{ it.spec_name }}</div>
              <div class="td">{{ it.quantity }}课时</div>
              <div class="td">￥{{ it.amount }}</div>
              <div class="td">￥{{ it.discount_amount }}</div>
            </div>
          </div>
        </div>
        <p class="sum-wrap">
          {{ mainData.payment_type === 1 ? "应收金额：" : "应退金额："
          }}<span class="red">￥{{ mainData.receivable_amount }}</span>
        </p>
      </div>
      <!-- 退课end -->

      <!-- 转课 -->
      <div v-if="mainData.order_type === 3">
        <div v-if="mainData.transferExpenditure">
          <div class="transfer-title">转出信息</div>
          <div class="table-wrap">
            <div class="th">
              <div class="td">订单号</div>
              <div class="td">业务形式</div>
              <div class="td">内容价格</div>
              <div class="td">单价</div>
              <div class="td">转课课时</div>
              <div class="td">转课金额</div>
              <div class="td">手续费</div>
            </div>
            <div
              class="item"
              v-for="item in mainData.transferExpenditure.list"
              :key="item.item_name"
            >
              <p class="title">
                【{{ item.is_combo ? "套餐" : "课程" }}】-
                {{ item.item_name }}
              </p>
              <div class="tr" v-for="(it, index) in item.list" :key="index">
                <div class="td">
                  {{ it.relation_order_no }}
                </div>
                <!-- <div class="td">{{ it.order_no }}</div> -->
                <div class="td">
                  <p v-if="it.business_type === 0">-</p>
                  <p v-if="it.business_type === 2">续费</p>
                  <p v-if="it.business_type === 1">新购</p>
                  <p v-if="it.business_type === 3">拓科</p>
                </div>
                <div class="td">{{ it.spec_name }}</div>
                <div class="td">￥{{ it.spec_unit_price }}</div>
                <div class="td">{{ it.quantity }}</div>
                <div class="td">￥{{ it.amount }}</div>
                <div class="td">￥{{ it.discount_amount }}</div>
              </div>
            </div>
          </div>
          <p class="sum-wrap">
            应退金额：<span class="red"
              >￥{{ mainData.transferExpenditure.receivable_amount }}</span
            >
          </p>
        </div>
        <div v-if="mainData.transferIncome">
          <div class="transfer-title">转入信息</div>
          <div class="table-wrap">
            <div class="th">
              <div class="td">内容价格</div>
              <div class="td">业务形式</div>
              <div class="td">转入课时</div>
              <div class="td">赠送课时</div>
              <div class="td">直减</div>
              <div class="td">小计</div>
            </div>
            <div
              class="item"
              v-for="item in mainData.transferIncome.list"
              :key="item.item_name"
            >
              <p class="title">
                【{{ item.is_combo ? "套餐" : "课程" }}】-
                {{ item.item_name }}
              </p>
              <div class="tr" v-for="(it, index) in item.list" :key="index">
                <div class="td">{{ it.spec_name }}</div>
                <div class="td">
                  <p v-if="it.business_type === 0">-</p>
                  <p v-if="it.business_type === 2">续费</p>
                  <p v-if="it.business_type === 1">新购</p>
                  <p v-if="it.business_type === 3">拓科</p>
                </div>
                <div class="td">{{ it.quantity }}课时</div>
                <div class="td">
                  {{
                    it.give_product_quantity === "0.00"
                      ? "0"
                      : it.give_product_quantity
                  }}￥
                </div>
                <div class="td">
                  ￥{{
                    it.discount_amount === "0.00" ? "0" : +it.discount_amount
                  }}
                </div>
                <div class="td">￥{{ it.receivable_amount }}</div>
              </div>
            </div>
          </div>
          <p class="sum-wrap">
            应收金额：<span class="red"
              >￥{{ mainData.transferIncome.receivable_amount }}</span
            >
          </p>
        </div>
      </div>
      <!-- 转课end -->

      <!-- 购活动-->
      <div v-if="mainData.order_type === 4">
        <div class="table-wrap">
          <div class="th">
            <div class="td">购买内容</div>
            <div class="td">业务形式</div>
            <div class="td">购买数量</div>
            <div class="td">赠送数量</div>
            <div class="td">直减</div>
            <!-- <div class="td">课程有效期</div> -->
            <div class="td">小计</div>
          </div>
          <div class="item" v-for="item in mainData.item" :key="item.item_name">
            <p class="title" :class="{ active: mainData.order_type === 4 }">
              {{ item.item_name }}
            </p>
            <div class="tr" v-for="(it, index) in item.list" :key="index">
              <div class="td">
                <span v-if="mainData.order_type === 1">{{
                  it.course_name
                }}</span>
                <span v-if="mainData.order_type === 4">
                  {{ item.item_name }}
                </span>
              </div>
              <div class="td">-</div>
              <div class="td">1</div>
              <div class="td">-</div>
              <div class="td">-</div>
              <div class="td">￥{{ it.receivable_amount }}</div>
            </div>
          </div>
        </div>
        <p class="sum-wrap">
          {{ mainData.payment_type === 1 ? "应收金额：" : "应退金额："
          }}<span class="red">￥{{ mainData.receivable_amount }}</span>
        </p>
      </div>
      <!-- 购活动end -->

      <!-- v2.56.x 收款明细 -->
      <div
        class="collection-detail"
        v-if="
          (mainData.order_type === 1 || mainData.order_type === 4) &&
          mainData.status !== 1
        "
      >
        <div class="text">收款明细</div>
        <el-table
          size="mini"
          :data="payDetailDialogData"
          stripe
          tooltip-effect="dark"
        >
          <el-table-column label="序号" width="200">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column
            label="支付时间"
            prop="payment_time"
          ></el-table-column>
          <el-table-column
            label="支付金额"
            prop="payment_amount"
          ></el-table-column>
          <el-table-column
            label="支付方式"
            prop="payment_name"
          ></el-table-column>
          <el-table-column label="操作人" prop="staff.name"></el-table-column>
        </el-table>
      </div>

      <!-- v2.56.x 退款明细 ，成功时展示-->
      <div
        class="collection-detail"
        v-if="
          (mainData.order_type === 2 || mainData.order_type === 5) &&
          mainData.status === 2
        "
      >
        <div class="text">退款明细</div>
        <el-table size="mini" :data="refundData" stripe tooltip-effect="dark">
          <el-table-column
            label="退款时间"
            prop="refund_time"
          ></el-table-column>
          <el-table-column
            label="退款金额"
            prop="refund_amount"
          ></el-table-column>
          <el-table-column label="退款方式" prop="refund_type">
          </el-table-column>
          <el-table-column label="操作人员" prop="refund_transfer_staff">
          </el-table-column>
          <el-table-column label="转账凭证" prop="refund_voucher">
            <template>
              <el-image
                v-if="mainData.refund_transfer"
                :src="mainData.refund_transfer.voucher_url"
                :preview-src-list="[mainData.refund_transfer.voucher_url]"
                class="refund-voucher"
              >
              </el-image>
              <div v-else>-</div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 注释：v2.56.x 金额统计 -->
      <div class="pay-info" v-if="mainData.status !== 1">
        <div class="total-wrap">
          <div class="wrap">
            <div class="part">合计：￥{{ mainData.completed_amount }}</div>
            <div class="part" v-if="mainData.refund_method === 1">
              原路回退：￥{{ mainData.completed_amount }}
            </div>
            <div class="part" v-else>
              <p v-for="item in mainData.payment_list" :key="item.payment_name">
                {{
                  item.payment_id === 6
                    ? mainData.payment_type === 2
                      ? "财务打款转账"
                      : item.payment_name
                    : item.payment_name
                }}：
                <!-- 开通支付，并且是待支付状态，显示 - -->
                <span
                  v-if="
                    online_pay &&
                    mainData.payment_type === 1 &&
                    mainData.status === 1
                  "
                >
                  -
                </span>
                <span v-else> ￥{{ item.payment_amount }}</span>
              </p>
            </div>
            <div class="part" v-show="mainData.payment_list.length === 0">
              <p>
                <span>-</span>
              </p>
            </div>
          </div>
          <!-- 注释：v2.56.x -->
          <!-- <div
            class="mwow-button-filled success"
            style="vertical-align: top; margin-left: 12px"
            @click="showPayDetail"
            v-if="mainData.payment_type === 1"
          >
            收款明细
          </div> -->
        </div>
      </div>
    </div>
    <!-- 再来一单弹窗 -->
    <el-dialog
      :visible.sync="orderAgainDialogVisible"
      width="280px"
      @close="cancelOrderAgainDialog"
      title="再来一单"
    >
      <div class="order-again-dialog flex">
        <div>
          订单的
          <span v-for="(item, index) in hasOffShelfTitle" :key="index">
            <span>{{ item }}</span>
            <span v-if="!(index === hasOffShelfTitle.length - 1)">、</span>
          </span>

          课程已下架，暂不支持再次下单
        </div>
        <div class="mwow-button-filled success" @click="cancelOrderAgainDialog">
          我知道了
        </div>
      </div>
    </el-dialog>
    <!-- 支付弹窗 -->
    <pay-dialog
      :visible.sync="payDialogVisible"
      :order-data="mainData"
      :pay-type="paymentType"
      @finish="init"
    ></pay-dialog>
    <!-- 收款明细弹窗，v2.56.x -->
    <!-- <el-dialog :visible.sync="payDetailVisible" width="50%" title="收款明细">
      <el-table
        size="mini"
        :data="payDetailDialogData"
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="序号">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="支付时间" prop="payment_time"></el-table-column>
        <el-table-column
          label="支付金额"
          prop="payment_amount"
        ></el-table-column>
        <el-table-column label="支付方式" prop="payment_name"></el-table-column>
        <el-table-column label="操作人" prop="staff.name"></el-table-column>
      </el-table>
    </el-dialog> -->
  </div>
</template>
<script>
import abolishDialog from "../abolishDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import { approvalDetailApi } from "@/api/approve";
import {
  orderDetail,
  exportOrderDetailApi,
  orderCancelApi,
  refundOrderCancelApi,
  getPayment,
  getPaymentDetailApi,
} from "@/api/order";
import { courseListApi } from "@/api/course";
import payDialog from "./payDialog.vue";
import { PageModule } from "@/store/module/page";

export default {
  components: {
    abolishDialog,
    payDialog,
  },
  data() {
    return {
      mainData: {
        student: {},
        payment_list: [],
        handle_time: "",
        transfer_join_student: {},
        refund_transfer: null,
      },
      studentData: {
        name: "",
        mobile: "",
        area_code: "",
      },
      approveData: {
        initiate_staff: {},
        approval_staff_list: [],
        status: 0,
        type: 1,
        cancel: {},
      },
      printing: false,
      studentId: 0,
      staffName: {},
      paymentType: [], // 支付类型
      orderAgainDialogVisible: false, // 再来一单弹窗
      hasOffShelfTitle: [], // 已下架的课程
      voucher_url: "",
      online_pay: false, // 是否开通支付
      refreshCD: 0, // 刷新cd
      payDialogVisible: false,
      // payDetailVisible: false,
      payDetailDialogData: [],
      refundData: [],
      firstFrom: "",
    };
  },
  created() {
    let search_info = PageModule.pageInfo.financialOrderList.search_info;
    this.firstFrom = search_info ? search_info.firstFrom : "";
    this.init();
    this.studentId = Number(this.$route.query.sid);
    const useInfo = window.localStorage.getItem("userInfo");
    this.staffName = JSON.parse(useInfo);
    getPayment().then((res) => {
      if (res.error_code === 0) {
        res.data.list.map((item) => {
          item.checked = false;
          item.total = 0;
        });

        this.paymentType = res.data.list;
        // 首位添加乐沃收银项
        this.paymentType.unshift({
          key: 999,
          value: "乐沃收银",
        });
        this.online_pay = res.data.online_pay;
      }
    });
  },
  methods: {
    init(initType) {
      const oid = Number(this.$route.query.id);
      const ono = this.$route.query.ono;
      orderDetail({
        order_id: oid ? oid : "",
        order_no: ono ? ono : "",
      }).then((res) => {
        if (res.error_code === 0) {
          if (initType === "refresh") {
            this.$message({
              type: "success",
              message: "刷新成功",
            });
          }
          res.data.original_pay_order_info.handle_time = res.data
            .original_pay_order_info.handle_time
            ? dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(res.data.original_pay_order_info.handle_time * 1000)
              )
            : "-";
          res.data.create_time = dateFormat(
            "YYYY-mm-dd HH:MM",
            new Date(res.data.create_time * 1000)
          );
          res.data.cancel_time = res.data.cancel_time
            ? dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(res.data.cancel_time * 1000)
              )
            : "-";
          res.data.handle_time = res.data.handle_time
            ? dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(res.data.handle_time * 1000)
              )
            : "-";
          // 废除时间
          if (res.data.cancel_log) {
            res.data.cancel_log.cancel_time = res.data.cancel_log.cancel_time
              ? dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(res.data.cancel_log.cancel_time * 1000)
                )
              : "-";
          }
          if (res.data.refund_fail_log) {
            res.data.refund_fail_log.create_time = res.data.refund_fail_log
              .create_time
              ? dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(res.data.refund_fail_log.create_time * 1000)
                )
              : "-";
          }
          if (res.data.order_type === 3) {
            res.data.transferIncome = res.data.item.reduce(
              (t, v) => {
                return (
                  v.list.filter((x) => {
                    if (x.payment_type === 1) {
                      t.receivable_amount =
                        (Math.round(Number(t.receivable_amount) * 100) +
                          Math.round(Number(x.receivable_amount) * 100)) /
                        100;
                      t.list.push(v);
                    }
                  }),
                  t
                );
              },
              {
                list: [],
                receivable_amount: 0,
              }
            );
            res.data.transferExpenditure = res.data.item.reduce(
              (t, v) => {
                return (
                  v.list.filter((x) => {
                    if (x.payment_type === 2) {
                      t.receivable_amount =
                        (Math.round(Number(t.receivable_amount) * 100) +
                          Math.round(Number(x.receivable_amount) * 100)) /
                        100;
                      t.list.push(v);
                    }
                  }),
                  t
                );
              },
              {
                list: [],
                receivable_amount: 0,
              }
            );
            res.data.transferExpenditure = res.data.item.reduce(
              (t, v) => {
                return (
                  v.list.filter((x) => {
                    if (x.payment_type === 2) {
                      t.receivable_amount =
                        Number(t.receivable_amount) +
                        Number(x.receivable_amount);
                      debugger;
                      t.list.push(v);
                    }
                  }),
                  t
                );
              },
              {
                list: [],
                receivable_amount: 0,
              }
            );
          }
          // 持平转课订单数据重复，只显示一条
          if (res.data.order_type === 3) {
            res.data.transferExpenditure.list.forEach((item, index) => {
              let arr = [];
              let arr1 = [];
              res.data.transferExpenditure.list[index].list.filter((it) => {
                // it 数据项中 business_type = 0，有 relation_order_no 字段，
                // it 数据项中 business_type > 0，缺少 relation_order_no 字段，
                if (it.business_type === 0) {
                  arr.push(it);
                }
                if (it.business_type > 0) {
                  arr1.push(it.business_type);
                }
              });
              // 如果 arr1 有 business_type 数据，就合并进去
              if (arr1[index]) {
                arr[index].business_type = arr1[index];
              }
              // 覆盖原数组
              res.data.transferExpenditure.list[index].list = arr;
            });
          }
          this.mainData = res.data;
          this.voucher_url = res.data.refund_transfer
            ? res.data.refund_transfer.voucher_url
            : "";
          this.studentData = res.data.student;
          if (res.data.payment_type === 1) {
            // 收支明细
            getPaymentDetailApi({
              order_id: this.mainData.order_id,
            }).then((res) => {
              res.data.list.map((item) => {
                item.payment_time = dateFormat(
                  "YYYY-mm-dd HH:MM",
                  new Date(item.payment_time * 1000)
                );
              });
              this.payDetailDialogData = res.data.list;
              this.payDetailVisible = true;
            });
          }
          if (res.data.payment_type === 2 && res.data.status === 2) {
            // 退款明细，退款记录只有一条，直接从详情中拿数据；原路退回时，操作人、凭证显示 - ，转账时正常展示
            let refundType;
            if (res.data.online_pay) {
              if (res.data.refund_method === 1) {
                refundType = "原路回退";
              }
              if (res.data.refund_method === 2) {
                refundType = "财务打款转账";
              }
            } else {
              refundType = res.data.payment_list[0].payment_name;
            }
            this.refundData = [
              {
                refund_time: res.data.handle_time,
                refund_amount: res.data.completed_amount,
                refund_type: refundType,
                refund_transfer_staff:
                  res.data.payment_list[0].payment_id === 6
                    ? res.data.refund_transfer_staff
                      ? res.data.refund_transfer_staff.name
                      : "-"
                    : "-",
                refund_voucher:
                  res.data.payment_list[0].payment_id === 6
                    ? res.data.refund_transfer
                      ? res.data.refund_transfer.voucher_url
                      : "-"
                    : "-",
              },
            ];
          }
          // 获取审批详情
          if (res.data.approval_id) {
            approvalDetailApi({
              approval_id: res.data.approval_id,
            }).then((result) => {
              result.data.create_time = result.data.create_time
                ? dateFormat(
                    "YYYY-mm-dd HH:MM",
                    new Date(result.data.create_time * 1000)
                  )
                : "-";
              result.data.cancel_time = result.data.cancel_time
                ? dateFormat(
                    "YYYY-mm-dd HH:MM",
                    new Date(result.data.cancel_time * 1000)
                  )
                : "-";
              result.data.approval_time = result.data.approval_time
                ? dateFormat(
                    "YYYY-mm-dd HH:MM",
                    new Date(result.data.approval_time * 1000)
                  )
                : "-";
              if (result.data.approval_staff_list.length > 0) {
                result.data.approval_staff_list.map((it) => {
                  it.approval_time = it.approval_time
                    ? dateFormat(
                        "YYYY-mm-dd HH:MM",
                        new Date(it.approval_time * 1000)
                      )
                    : "-";
                });
              }
              this.approveData = result.data;
            });
          }
        }
      });
    },
    handleRefresh() {
      if (this.refreshCD > 0) {
        return false;
      }
      this.refreshCD = 5;
      this.init("refresh");
      let timer = setInterval(() => {
        let now = this.refreshCD - 1;
        this.refreshCD = now;
        if (now === 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    handlePrint() {
      exportOrderDetailApi({
        order_id: this.mainData.order_id,
      }).then((res) => {
        window.open(res.data.url, "_blank");
      });
    },

    handleCancelRefund() {
      this.$confirm("确定取消？", "订单退款取消", {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      })
        .then(() => {
          refundOrderCancelApi({
            refund_order_id: this.mainData.order_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "取消成功!",
              });
              this.init();
            } else if (res.error_code === 21001001) {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    // 处理订单信息支付状态的文本类型
    handlePaymentStatus() {
      if (this.mainData.payment_type === 1) {
        // 原购课订单正在退单
        if (this.mainData.org_pay_order_chargeback_exist) {
          return "已付款 - 部分付款（退单中）";
        }
        switch (this.mainData.status) {
          case 1:
            return "待付款";
          case 2:
            return "已付款";
          case 4:
            if (this.mainData.cancel_type === 1) {
              return "已取消 - 系统取消";
            } else if (this.mainData.cancel_type === 2) {
              return "已取消 - 员工取消";
            } else if (this.mainData.cancel_type === 3) {
              return "已取消 - 部分付款（订单退款）";
            }
            return "已取消";
          case 5:
            return "已付款 - 部分付款";
        }
      }
      if (this.mainData.payment_type === 2) {
        if (this.mainData.refund_failed) {
          return "退款失败";
        }
        switch (this.mainData.status) {
          case 1:
            return "退款中";
          case 2:
            return "退款成功";
          case 3:
            return "已废除";
          case 4:
            return "已取消";
        }
      }
      return "-";
    },
    // 跳转订单编辑
    toEdit() {
      const oid = this.$route.query.id;
      this.$router.push({
        name: "orderManageEdit",
        query: {
          id: oid,
          from: "orderManageDetail",
        },
      });
    },
    // 控制支付方式的弹窗
    handlePaymentTypeDialog() {
      this.payDialogVisible = true;
    },
    // 取消订单
    handelCancelOrder() {
      this.$confirm(
        "确定对该订单进行取消吗？",
        `取消订单-${this.mainData.order_no}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled",
        }
      )
        .then(() => {
          orderCancelApi({ order_id: this.mainData.order_id }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                type: "success",
                message: "取消成功",
              });
              this.init();
            }
          });
        })
        .catch(() => {});
    },
    // 退款
    toRefund() {
      let ids = [];
      this.mainData.item.map((item) => {
        item.list.map((it) => {
          ids.push(it.item_id);
        });
      });
      let history = sessionStorage.getItem(
        "student_order_refund_route_history"
      );
      if (history) {
        let json = JSON.parse(history);
        if (json.student_id) {
          sessionStorage.setItem(
            "student_order_refund_route_history",
            JSON.stringify({
              student_id: json.student_id,
              buy_order_id: this.mainData.order_id,
            })
          );
        }
      }
      this.$router.push({
        name: "orderRefund",
        query: {
          item_ids: ids.join(","),
          sid: this.mainData.student.student_id,
          complete: "0", // 分期购买且未付满
        },
      });
    },
    // 再来一单，跳转到购课确认页面
    toBuyConfirm() {
      const courseIdArr = [];
      this.mainData.item.map((item) => {
        item.list.map((it) => {
          courseIdArr.push(it.product_id);
        });
      });
      // 查看课程是否支持购买
      const params = {
        page: 1,
        page_size: 10,
      };
      params.course_ids = courseIdArr;
      courseListApi(params).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            if (item.sales_status === 2) {
              this.hasOffShelfTitle.push(item.title);
            }
          });
          if (!this.hasOffShelfTitle.length) {
            setTimeout(() => {
              this.$router.push({
                name: "buyCourseConfirm",
                query: {
                  id: String(this.mainData.student.student_id),
                  course_id: courseIdArr,
                },
              });
            }, 500);
          } else {
            this.orderAgainDialogVisible = true;
          }
        }
      });
    },
    cancelOrderAgainDialog() {
      this.orderAgainDialogVisible = false;
    },
    // 如果是退课、退单，跳转到原订单(购买课程订单)详情页
    toOrderDetail(val) {
      this.$router.push({
        name: "orderManageDetail",
        query: {
          ono: val.relation_order_no,
          id: this.mainData.original_pay_order_info.order_id,
          fromOrderId: this.mainData.order_id,
        },
      });
      this.init();
    },
    toApproveDetail() {
      this.$router.push({
        name: "approveLogDetail",
        query: {
          id: String(this.approveData.approval_id),
          fromOrderId: this.mainData.order_id,
        },
      });
    },
    handleBack() {
      if (this.$route.query.fromOrderId) {
        this.$router.push({
          name: "orderManageDetail",
          query: {
            id: this.$route.query.fromOrderId,
          },
        });
        this.init();
        this.$router.go(-1);
      }
      /*
        学员详情-》订单A-》退课页-》订单B
        退课页跳出是replace的，产品要求订单B点返回直接回学员详情，根据sessionStorage的student_order_refund_route_history判断
        当student_id，buy_order_id，refund_order_id都存在时，点击返回直接返回student_id的学员详情
      */
      let history = sessionStorage.getItem(
        "student_order_refund_route_history"
      );
      // 从财务中心来的 订单列表 和 乐沃收银跳转过来的，返回时需要携带 from 参数
      let historyFinance = sessionStorage.getItem("finance");
      // 学员退课 》订单详情 》审批详情 》返回 》返回 》返回
      // 从学员退课，到订单详情，到审批详情，能够一步一步的返回
      if (JSON.parse(historyFinance) === "orderManage_orderList") {
        if (this.firstFrom) {
          this.$router.go(-1);
        } else {
          this.$router.push({
            name: "orderManage",
            query: {
              from: "order_detail",
            },
          });
        }
      } else if (JSON.parse(historyFinance) === "storeWallet_Tabdetail") {
        this.$router.push({
          name: "storeWallet",
          query: {
            from: "order_detail",
          },
        });
      } else if (history) {
        let json = JSON.parse(history);
        if (json.student_id && json.buy_order_id && json.refund_order_id) {
          sessionStorage.removeItem("student_order_refund_route_history");
          this.$router.push({
            name: "studyDetails",
            query: {
              id: json.student_id,
              from: "buy_order_details",
            },
          });
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    // 收款明细
    // showPayDetail() {
    //   getPaymentDetailApi({
    //     order_id: this.mainData.order_id,
    //   }).then((res) => {
    //     res.data.list.map((item) => {
    //       item.payment_time = dateFormat(
    //         "YYYY-mm-dd HH:MM",
    //         new Date(item.payment_time * 1000)
    //       );
    //     });
    //     this.payDetailDialogData = res.data.list;
    //     this.payDetailVisible = true;
    //   });
    // },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}
.printing {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999999999;
  background: #fff;
}
.detail-head {
  display: flex;
  margin: 16px 72px;
}
.approve-wrap {
  flex: 3;
  position: relative;
  margin-right: 16px;
  display: flex;
  flex-direction: column;
  .status-tag {
    position: absolute;
    top: 14px;
    right: 14px;
  }
  .approve-title {
    height: 42px;
    line-height: 42px;
    padding: 0 22px;
    color: #5c5d5e;
    font-size: 14px;
    font-weight: bold;
    &.wait {
      background-color: #ffeff0;
    }
    &.cancel {
      background-color: #fff5e3;
    }
    &.pass {
      background-color: #e6faf6;
    }
    &.reject {
      background-color: #f2f6fa;
    }
  }
  .approve-content {
    flex: 1;
    padding: 19px 22px 50px 22px;
    border: 1px solid #e1e5e9;
    border-top: 0;
    position: relative;
    .rows {
      .row {
        position: relative;
        margin-bottom: 8px;
        padding-bottom: 8px;
        &::after {
          content: "";
          position: absolute;
          top: 26px;
          left: 9px;
          bottom: 0;
          border-right: 1px solid #e7e8ea;
        }
        &:last-child {
          &::after {
            display: none;
          }
        }
        .title {
          display: flex;
          align-items: center;
          font-size: 14px;
          line-height: 18px;
          color: #5c5d5e;
          margin-bottom: 8px;
          &.bold {
            font-weight: bold;
          }
          .icon {
            margin-right: 10px;
          }
          .border {
            margin: 0 6px;
            color: #e7e8ea;
          }
          .status {
            margin-left: 6px;
          }
        }
        .time {
          margin-left: 28px;
          font-size: 12px;
          color: #adaeae;
          line-height: 14px;
        }
        .desp {
          margin-top: 8px;
          margin-left: 28px;
          color: #5c5d5e;
          line-height: 14px;
          font-size: 12px;
        }
      }
      .voucher {
        .title {
          padding: 0 28px;
        }
        .el-image {
          vertical-align: text-top;
          width: 100px;
          // height: 100px;
        }
      }
    }
    .btns {
      position: absolute;
      bottom: 10px;
      left: 49px;
      .btn {
        width: 46px;
        text-align: center;
        margin-right: 20px;
      }
    }
  }
}
.order-wrap {
  flex: 2;
  display: flex;
  flex-direction: column;
  .order-title {
    height: 42px;
    line-height: 42px;
    font-weight: bold;
    padding: 0 21px;
    color: #07d1aa;
    font-size: 14px;
    background-color: #f2f6fa;
    position: relative;
    display: flex;
    &.limit {
      display: block;
      .text {
        margin-right: 24px;
      }
    }
    .text {
      flex: 1;
    }
    .payment-status {
      font-weight: normal;
      .repeal {
        position: absolute;
        top: 14px;
        right: 14px;
      }
    }
  }
  .order-content {
    flex: 1;
    padding: 19px 20px;
    border: 1px solid #e1e5e9;
    border-top: 0;
    .user {
      font-size: 16px;
      color: #5c5d5e;
      margin-bottom: 30px;
      line-height: 16px;
      .name {
        font-weight: bold;
        padding-right: 10px;
        margin-right: 10px;
        border-right: 1px solid #e7e8ea;
      }
    }
    .form {
      .item {
        font-size: 14px;
        color: #5c5d5e;
        line-height: 14px;
        margin-bottom: 11px;
        display: flex;
        .label {
          width: 70px;
          text-align: right;
        }
        .value {
          flex: 1;
        }
      }
      .withdrawal {
        margin-top: 0px !important;
      }
      .create-staff {
        margin-top: 30px;
      }
      .wait-amount {
        align-items: center;
        .value {
          flex: 0;
        }
        .pay-btn {
          margin-left: 10px;
        }
      }

      .operator {
        margin-top: 30px;
      }
    }
  }
}
.cancel-order-wrap {
  margin: 20px 72px 20px 72px;
  padding: 26px 112px 12px 26px;
  border: 1px solid #d9dadb;
  border-radius: 4px;
  color: #5c5d5e;
  font-size: 12px;
  position: relative;
  line-height: 28px;
  .title {
    font-size: 14px;
    margin-bottom: 18px;
    font-weight: bold;
  }
  .info-box {
    margin-left: 50px;
  }
}

.table-wrap {
  margin: 0 72px;
  font-size: 12px;
  color: #5c5d5e;
  line-height: 42px;
  text-align: center;
  .th,
  .tr {
    display: flex;
    .td:nth-child(1) {
      flex: 1;
      word-break: break-all;
    }
    .td:nth-child(2) {
      flex: 1;
    }
    .td:nth-child(3) {
      flex: 1;
    }
    .td:nth-child(4) {
      flex: 1;
    }
    .td:nth-child(5) {
      flex: 1;
    }
    .td:nth-child(6) {
      flex: 1;
    }
    .td:nth-child(7) {
      flex: 1;
    }
  }
  .th {
    background-color: #f2f6fa;
    margin-bottom: 10px;
    .td {
      font-weight: bold;
    }
  }
  .tr {
    border-bottom: 1px solid #e1e5e9;
    &:last-child {
      border-bottom: 0;
    }
    .td {
    }
  }
  .item {
    margin-bottom: 10px;
    border: 1px solid #e1e5e9;
    .title {
      padding-left: 28px;
      font-weight: bold;
      background: #f2f6fa;
      text-align: left;
    }
    .title.active {
      padding-left: 58px;
    }
  }
}
.sum-wrap {
  text-align: right;
  margin: 24px 72px;
  font-size: 18px;
  color: #5c5d5e;
  .red {
    font-size: 22px;
    color: #f56c6c;
  }
  span {
    margin-right: 12px;
  }
}
/deep/.collection-detail {
  margin: 0 72px;
  .el-table::before {
    height: 0px !important;
  }
  .text {
    margin: 20px 0;
    font-size: 14px;
    font-weight: 700;
    color: #5c5d5e;
  }
  .refund-voucher {
    width: 100px;
  }
}
.pay-info {
  border-top: 1px solid #e7e8ea;
  margin: 0 72px;
  // .list-item {
  //   padding: 0 20px;
  //   line-height: 24px;
  //   margin: 12px 0;
  //   font-size: 12px;
  //   color: #5c5d5e;
  //   .tag {
  //     border: 1px solid #e7e8ea;
  //     padding: 4px 8px;
  //     margin-right: 8px;
  //     border-radius: 4px;
  //   }
  // }
  .total-wrap {
    margin: 15px 0;
    font-size: 12px;
    color: #5c5d5e;
    .label {
      display: inline-block;
      vertical-align: top;
    }
    .wrap {
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      padding: 18px 0;
      display: inline-flex;
      .part {
        padding: 0 20px;
        display: flex;
        border-right: 1px solid #e7e8ea;
        p {
          margin-right: 12px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.transfer-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 15px 75px;
}

.payment-type-dialog-visible {
  .item {
    .box {
      margin-bottom: 20px;
      s .text {
        margin-left: 10px;
      }
    }
    /deep/ .box {
      .is-checked {
        .el-radio__inner {
          border-color: #07d1aa;
          background: #07d1aa;
        }
        .el-radio__label {
          color: #07d1aa;
        }
      }
    }
  }
}

/deep/ .payment-type-dialog-visible .el-dialog__header {
  border: none !important;
}
.confirm-dialog {
  .info-wrap {
    .head {
      font-size: 14px;
      color: #5c5d5e;
      margin: 0 0 20px 0;
      .name {
        font-weight: bold;
        padding-right: 12px;
        margin-right: 12px;
        border-right: 1px solid #e7e8ea;
      }
    }
    .table-wrap {
      margin: 0 72px;
      font-size: 12px;
      color: #5c5d5e;
      line-height: 42px;
      text-align: center;
      .th,
      .tr {
        display: flex;
        .td:nth-child(1) {
          flex: 1;
        }
        .td:nth-child(2) {
          flex: 1;
        }
        .td:nth-child(3) {
          flex: 1;
        }
        .td:nth-child(4) {
          flex: 1;
        }
        .td:nth-child(5) {
          flex: 1;
        }
        .td:nth-child(6) {
          flex: 1;
        }
        .td:nth-child(7) {
          flex: 1;
        }
      }
      .th {
        background-color: #f2f6fa;
        margin-bottom: 10px;
        .td {
          font-weight: bold;
        }
      }
      .tr {
        border-bottom: 1px solid #e1e5e9;
        &:last-child {
          border-bottom: 0;
        }
        .td {
        }
      }
      .item {
        margin-bottom: 10px;
        border: 1px solid #e1e5e9;
        .title {
          padding-left: 28px;
          font-weight: bold;
          background: #f2f6fa;
          text-align: left;
        }
      }
    }
    .sum-wrap {
      text-align: right;
      margin: 24px 0;
      font-size: 14px;
      .red {
        color: #f56c6c;
      }
    }
  }
  .pay-info {
    border-top: 1px solid #e7e8ea;
    margin: 0 -20px;
    p {
      padding: 0 20px;
      line-height: 24px;
      margin: 8px 0;
      font-size: 12px;
      color: #5c5d5e;
      .tag {
        border-right: 1px solid #e7e8ea;
        padding-right: 8px;
        margin-right: 8px;
        &:last-child {
          border-right: 0;
        }
      }
      .red {
        color: #f56c6c;
      }
    }
  }
  .warning-info {
    line-height: 40px;
    background-color: #fff7e9;
    font-size: 12px;
    color: #ffb940;
    text-align: center;
    margin: 0 -20px 21px -20px;
    i {
      margin-right: 8px;
      font-size: 16px;
      vertical-align: middle;
    }
  }
  .bottom-btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 12px;
    }
  }
}
.order-pay-wrap {
  margin: 0 72px;
  .block {
    border: 1px solid #d9dadb;
    border-radius: 4px;
    padding: 26px;
    margin-bottom: 10px;
    line-height: 28px;
    font-size: 12px;
    .title {
      font-size: 14px;
      color: #5c5d5e;
      margin-bottom: 21px;
    }
    .pay-time {
      color: #5c5d5e;
      display: flex;

      .label {
        margin-right: 10px;
      }
      .content {
        flex: 1;
      }
    }
    .item {
      display: flex;
      margin-bottom: 12px;
      color: #5c5d5e;
      .label {
        min-width: 70px;
      }
      .content {
        flex: 1;
        .red {
          color: #f56c6c;
        }
        .box {
          display: inline-block;
          border-radius: 4px;
          &.active {
            border-color: #07d1aa;
          }
          .text {
            border-right: 1px solid #e7e8ea;
            padding-right: 8px;
            margin-right: 8px;
          }
          &:last-child {
            .text {
              border: none;
            }
          }
          .input {
            font-size: 12px;
            color: #5c5d5e;
            width: 60px;
            border: 0;
          }
        }
      }
      .belong-wrap {
        .tag {
          display: inline-block;
          vertical-align: middle;
          background-color: #f6fafc;
          padding: 0 12px;
          border-radius: 4px;
          margin-right: 12px;
          white-space: nowrap;
          margin-bottom: 10px;
        }
        .btn {
          color: #07d1aa;
          cursor: pointer;
          white-space: nowrap;
        }
      }
    }
  }
}

.transfer-account-wrap {
  margin: 0 72px;
  .block {
    border: 1px solid #d9dadb;
    border-radius: 4px;
    padding: 26px;
    margin-bottom: 10px;
  }
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.order-again-dialog {
  flex-direction: column;
  .success {
    margin-top: 20px;
    border-radius: 30px !important;
  }
}
</style>
